import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {PersonGender} from '@domain/common/common';

@Pipe({
  name: 'scheduleGender',
  pure: true
})
export class ScheduleGenderPipe implements PipeTransform {

  private readonly transloco = inject(TranslocoService);

  public transform(gender: PersonGender | null | undefined): string | null {
    if (!gender) {
      return null;
    }
    return this.transloco.translate(`enum.Activity.Gender.${gender}`).toLowerCase();
  }

}
